<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-layout justify-center>
          <v-flex xs12 sm12 md6>
            <v-card>
              <v-toolbar dark>
                <v-toolbar-title>ログイン</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-model="userid" placeholder="ユーザIDを入力してください" prepend-icon="person" name="login" label="ユーザID" type="text"></v-text-field>
                  <v-text-field v-model="pass" placeholder="パスワードを入力してください" id="password" prepend-icon="lock" name="password" label="パスワード" type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">ログイン</v-btn>
              </v-card-actions>
              <v-alert
                :value="alert"
                type="error"
                transition="scale-transition"
              >
                {{msg}}
              </v-alert>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Auth from '@/components/Auth'
export default {
  mixins: [ Auth ],
  data: () => ({
    drawer: false
  }),
  props: {
    source: String
  }
}
</script>

<style lang="stylus">
</style>
